import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BreadcrumbService } from '@core/services/breadcrumb.service';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
})
export class PageHeaderComponent {
  @Input() icon = '';
  @Input() title = '';
  @Input() subtitle = '';

  readonly breadcrumbService = inject(BreadcrumbService);
  readonly parentUrl = toSignal(this.breadcrumbService.parentUrl$, { initialValue: null });
}
